import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
export function CardBrandsChart() {
  // Mock data
  const data = [{
    name: 'Visa',
    value: 45,
    color: '#4F6EB1'
  }, {
    name: 'MasterCard',
    value: 35,
    color: '#D16B5F'
  }, {
    name: 'American Express',
    value: 12,
    color: '#6E9FD9'
  }, {
    name: 'Discover',
    value: 5,
    color: '#D9984B'
  }, {
    name: 'JCB',
    value: 3,
    color: '#476F9A'
  }];
  return <ResponsiveContainer width="100%" height="100%" data-id="element-641">
      <PieChart data-id="element-642">
        <Pie data={data} cx="50%" cy="50%" innerRadius={80} outerRadius={120} fill="#8884d8" dataKey="value" label={({
        name,
        percent
      }) => `${name}: ${(percent * 100).toFixed(0)}%`} data-id="element-643">
          {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-644" />)}
        </Pie>
        <Tooltip formatter={value => [`${value}%`, 'Percentage']} data-id="element-645" />
        <Legend layout="vertical" align="right" verticalAlign="middle" data-id="element-646" />
      </PieChart>
    </ResponsiveContainer>;
}